import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Overseas Job Placement Summary ")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Partner", -1)
const _hoisted_13 = { class: "col-md-2 mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_15 = { class: "position-relative mt-7" }
const _hoisted_16 = { class: "row w-100 mb-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 my-auto" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "m-0" }, "Overseas Job Placement Summary")
], -1)
const _hoisted_18 = {
  class: "col-md-6 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "col-md-12 table-responsive sticky p-0" }
const _hoisted_26 = { class: "table table-borderless gy-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      rowspan: "3"
    }, " Sl "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      rowspan: "3"
    }, " Training Partner "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      colspan: "3",
      class: "border border-grey text-center"
    }, " Enrollment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      colspan: "3",
      class: "border border-grey text-center"
    }, " Assessment "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      colspan: "3",
      class: "border border-grey text-center"
    }, " Certification "),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"border":"1px solid #50cd89 !important","text-align":"center"},
      colspan: "7",
      class: "border border-grey text-center"
    }, " Job Placement ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Total "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Male "),
    /*#__PURE__*/_createElementVNode("th", {
      rowspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Female "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Local "),
    /*#__PURE__*/_createElementVNode("th", {
      colspan: "2",
      style: {"border":"1px solid #50cd89 !important","text-align":"center"}
    }, " Overseas ")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Male "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Female "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Male "),
    /*#__PURE__*/_createElementVNode("th", { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }, " Female ")
  ])
], -1)
const _hoisted_28 = { style: {} }
const _hoisted_29 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }
const _hoisted_30 = {
  colspan: "18",
  style: {"border":"1px solid #50cd89 !important"}
}
const _hoisted_31 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_32 = { style: {"border":"1px solid #50cd89 !important","text-align":"left"} }
const _hoisted_33 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_34 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_35 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_36 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_37 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_38 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_39 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_40 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_41 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_42 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_43 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_44 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_45 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_46 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_47 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_48 = { style: {"border":"1px solid #50cd89 !important","text-align":"center"} }
const _hoisted_49 = {
  colspan: "2",
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}
const _hoisted_50 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_51 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_52 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_53 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_54 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_55 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_56 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_57 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_58 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_59 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_60 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_61 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_62 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_63 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_64 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_65 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"}
}, " Total ", -1)
const _hoisted_67 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_68 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_69 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_70 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_71 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_72 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_73 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_74 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_75 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_76 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_77 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_78 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_79 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_80 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_81 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }
const _hoisted_82 = { style: {"border":"1px solid #50cd89 !important","text-align":"center","font-weight":"bold"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _hoisted_10,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.tranche_id,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tranche_id) = $event)),
                  options: _ctx.optionsTranche,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Tranche",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.entity_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.entity_id) = $event)),
                  options: _ctx.optionsTPartner,
                  mode: "tags",
                  "clear-on-select": false,
                  placeholder: "Select Training Partner",
                  "close-on-select": false,
                  searchable: true,
                  "create-option": true
                }, null, 8, ["modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getJobPlacementInfo())),
                  type: "button",
                  class: "btn btn-success mt-6 p-3",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_14
                ])
              ])
            ]),
            (_ctx.showCourseNotice == true)
              ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                          title: "Download Xlse",
                          "data-v-54b12dc8": "",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.exportTrainee()))
                        }, _hoisted_20),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Download PDF",
                          "data-v-54b12dc8": "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.downloadPdf()))
                        }, _hoisted_22),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                          title: "Print",
                          "data-v-54b12dc8": "",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.printPdf()))
                        }, _hoisted_24)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("table", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("tbody", _hoisted_28, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overseasJobReport, (info, key) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                              _createElementVNode("tr", _hoisted_29, [
                                _createElementVNode("td", _hoisted_30, [
                                  _createElementVNode("b", null, _toDisplayString(info?.trancheInfo?.label), 1)
                                ])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info?.trancheInfo
                          ?.entity, (data, inx) => {
                                return (_openBlock(), _createElementBlock("tr", { key: inx }, [
                                  _createElementVNode("td", _hoisted_31, _toDisplayString(data?.sl), 1),
                                  _createElementVNode("td", _hoisted_32, _toDisplayString(data?.entity_short_name), 1),
                                  _createElementVNode("td", _hoisted_33, _toDisplayString(data?.enrollment), 1),
                                  _createElementVNode("td", _hoisted_34, _toDisplayString(data?.maleEnrollment), 1),
                                  _createElementVNode("td", _hoisted_35, _toDisplayString(data?.femaleEnrollment), 1),
                                  _createElementVNode("td", _hoisted_36, _toDisplayString(data?.assessment), 1),
                                  _createElementVNode("td", _hoisted_37, _toDisplayString(data?.maleAssessment), 1),
                                  _createElementVNode("td", _hoisted_38, _toDisplayString(data?.femaleAssessment), 1),
                                  _createElementVNode("td", _hoisted_39, _toDisplayString(data?.certification), 1),
                                  _createElementVNode("td", _hoisted_40, _toDisplayString(data?.maleCertification), 1),
                                  _createElementVNode("td", _hoisted_41, _toDisplayString(data?.femaleCertification), 1),
                                  _createElementVNode("td", _hoisted_42, _toDisplayString(data?.employment), 1),
                                  _createElementVNode("td", _hoisted_43, _toDisplayString(data?.maleEmployment), 1),
                                  _createElementVNode("td", _hoisted_44, _toDisplayString(data?.femaleEmployment), 1),
                                  _createElementVNode("td", _hoisted_45, _toDisplayString(data?.localMaleEmployment), 1),
                                  _createElementVNode("td", _hoisted_46, _toDisplayString(data?.localFemaleEmployment), 1),
                                  _createElementVNode("td", _hoisted_47, _toDisplayString(data?.overseasMaleEmployment), 1),
                                  _createElementVNode("td", _hoisted_48, _toDisplayString(data?.overseasFemaleEmployment), 1)
                                ]))
                              }), 128)),
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", _hoisted_49, " Subtotal(" + _toDisplayString(info?.trancheInfo?.label) + ") ", 1),
                                _createElementVNode("td", _hoisted_50, _toDisplayString(_ctx.numberWithCommas(
                                      info?.trancheInfo?.subTotalEnrollment
                                    )), 1),
                                _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.numberWithCommas(
                                      info?.trancheInfo?.subTotalMaleEnrollment
                                    )), 1),
                                _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.numberWithCommas(
                                      info?.trancheInfo?.subTotalFemaleEnrollment
                                    )), 1),
                                _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalAssessment
                              )), 1),
                                _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalMaleAssessment
                              )), 1),
                                _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalFemaleAssessment
                              )), 1),
                                _createElementVNode("td", _hoisted_56, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalCertification
                              )), 1),
                                _createElementVNode("td", _hoisted_57, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalMaleCertification
                              )), 1),
                                _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalFemaleCertification
                              )), 1),
                                _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalEmployment
                              )), 1),
                                _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalMaleEmployment
                              )), 1),
                                _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalFemaleEmployment
                              )), 1),
                                _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalLocalMaleEmployment
                              )), 1),
                                _createElementVNode("td", _hoisted_63, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalLocalFemaleEmployment
                              )), 1),
                                _createElementVNode("td", _hoisted_64, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalOverseasMaleEmployment
                              )), 1),
                                _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.numberWithCommas(
                                info?.trancheInfo?.subTotalOverseasFemaleEmployment
                              )), 1)
                              ])
                            ], 64))
                          }), 128)),
                          _createElementVNode("tr", null, [
                            _hoisted_66,
                            _createElementVNode("td", _hoisted_67, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalEnrollment)), 1),
                            _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalMaleEnrollment)), 1),
                            _createElementVNode("td", _hoisted_69, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalFemaleEnrollment)), 1),
                            _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalAssessment)), 1),
                            _createElementVNode("td", _hoisted_71, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalMaleAssessment)), 1),
                            _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalFemaleAssessment)), 1),
                            _createElementVNode("td", _hoisted_73, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalCertification)), 1),
                            _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalMaleCertification)), 1),
                            _createElementVNode("td", _hoisted_75, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalFemaleCertification)), 1),
                            _createElementVNode("td", _hoisted_76, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalEmployment)), 1),
                            _createElementVNode("td", _hoisted_77, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalMaleEmployment)), 1),
                            _createElementVNode("td", _hoisted_78, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalFemaleEmployment)), 1),
                            _createElementVNode("td", _hoisted_79, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalLocalMaleEmployment)), 1),
                            _createElementVNode("td", _hoisted_80, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalLocalFemaleEmployment)), 1),
                            _createElementVNode("td", _hoisted_81, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalOverseasMaleEmployment)), 1),
                            _createElementVNode("td", _hoisted_82, _toDisplayString(_ctx.numberWithCommas(_ctx.TotalOverseasFemaleEmployment)), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}